﻿import window from 'window';
import document from 'document';

import { addressFinder } from '../scc/address-finder';
import { enableFormSubmission } from '../form/enable-form';

export const addressHandler = () => {

    const addressListKey = 'addressList';

    const _selectors = {
        root: '.scc-entry-module',
        field: '.form-field-group__input',
        addressList: 'current-js-address-list',
        searchButton: '.find-address-btn',
        errorMessage: '.form-field-group__error'
    };

    const getAddressElements = () => {
        const yearsAtAddress = document.getElementById('CurrentAddressViewModel_YearsAtAddress');
        const monthsAtAddress = document.getElementById('CurrentAddressViewModel_MonthsAtAddress');
        const previousAddress = document.getElementById('PreviousAddress');
        return {
            'yearsAtAddress': yearsAtAddress,
            'monthsAtAddress': monthsAtAddress,
            'previousAddress': previousAddress
        };
    }

    const getPreviousAddressRequired = (addressElements) => {
        const targetYearsAtAddressValue = isNaN(parseInt(addressElements.yearsAtAddress.value)) ? -1 : parseInt(addressElements.yearsAtAddress.value);
        const targetMonthsAtAddressValue = isNaN(parseInt(addressElements.monthsAtAddress.value)) ? -1 : parseInt(addressElements.monthsAtAddress.value);

        return previousAddressRequired(targetYearsAtAddressValue, targetMonthsAtAddressValue);
    }

    const isPreviousAddressRequired = () => {
        const addressElements = getAddressElements();

        return getPreviousAddressRequired(addressElements);
    }

    const getMinYearsAtAddress = () => {
        return window.scc_state ? window.scc_state.minyearsataddress : 3;
    }

    const previousAddressRequired = (targetYearsAtAddressValue, targetMonthsAtAddressValue) => {
        const thresholdYears = getMinYearsAtAddress();
        return targetYearsAtAddressValue < thresholdYears && targetYearsAtAddressValue != -1
             || targetYearsAtAddressValue === -1 && targetMonthsAtAddressValue >= 0;
    }

    const setFormFieldsVisibility = (addressElements) => {
        const targetPreviousAddress = addressElements.previousAddress;
        const isRequired = getPreviousAddressRequired(addressElements);

        if (isRequired) {
            targetPreviousAddress.style.display = "block";
        }
        else {
            targetPreviousAddress.style.display = "none";
        }
    }

    const getPreviousAddressFields = () => {
        return document.getElementById("PreviousAddress").getElementsByClassName('required-item');
    }

    const resetPreviousAddressForm = (root) => {
        const addressElements = getAddressElements();

        const previousAdressFields = Array.from(getPreviousAddressFields());

        if (isPreviousAddressRequired()) {
            setFieldsRequiredAttribute(previousAdressFields, true);

            _selectors['context'] = 'previous';
            _selectors[addressListKey] = 'previous-js-address-list';
            _selectors['addressRoot'] = '.previous-address-layout';
            _selectors['searchField'] = '.js-address-finder__previous';
            _selectors['resultsContainer'] = '.address-search__previous';

            const previousAddressFinder = addressFinder();
            previousAddressFinder.init(_selectors);        
        } else{
            setFieldsRequiredAttribute(previousAdressFields, false);
        }
        setFormFieldsVisibility(addressElements);
        enableFormSubmission().init(root);
    }

    const setCurrentAddressForm = (addressElements) => {
        setFormFieldsVisibility(addressElements);

        _selectors['context'] = 'current';
        _selectors['addressRoot'] = '.current-address-layout';
        _selectors['searchField'] = '.js-address-finder__current';
        _selectors['resultsContainer'] = '.address-search__current';

        const currentAddressFinder = addressFinder();
        currentAddressFinder.init(_selectors);
    }

    const setFieldsRequiredAttribute = (fields, isRequired) => {

        fields.map((field) => {
            if (isRequired)
                field.setAttribute('required', 'required');
            else {
                field.removeAttribute('required');
            }
        });

    }

    const init = () => {
        
        const root = document.querySelector(_selectors.root);
        if (root) {
        
            const addressElements = getAddressElements();

            addressElements.yearsAtAddress.onchange = () => {
                resetPreviousAddressForm(root);
            };
            addressElements.monthsAtAddress.onchange = () => {
                resetPreviousAddressForm(root);
            };
            setCurrentAddressForm(addressElements);
        }
    }

    return {
        init: init
    };
};
